
export interface EndpointBenchmark {
  endpoint: string;
  yourScore: number;
  industryAvg: number;
  topQuartile: number;
  concernLevel: 'very_low' | 'low' | 'medium' | 'high' | 'very_high';
}

export const endpointBenchmarkData: EndpointBenchmark[] = [
  {
    endpoint: 'Acute Toxicity',
    yourScore: 85,
    industryAvg: 72,
    topQuartile: 92,
    concernLevel: 'low'
  },
  {
    endpoint: 'Skin Sensitization',
    yourScore: 78,
    industryAvg: 68,
    topQuartile: 88,
    concernLevel: 'low'
  },
  {
    endpoint: 'Carcinogenicity',
    yourScore: 92,
    industryAvg: 75,
    topQuartile: 95,
    concernLevel: 'very_low'
  },
  {
    endpoint: 'Reproductive Toxicity',
    yourScore: 88,
    industryAvg: 70,
    topQuartile: 94,
    concernLevel: 'low'
  },
  {
    endpoint: 'Endocrine Disruption',
    yourScore: 65,
    industryAvg: 58,
    topQuartile: 82,
    concernLevel: 'medium'
  },
  {
    endpoint: 'Aquatic Toxicity',
    yourScore: 70,
    industryAvg: 62,
    topQuartile: 85,
    concernLevel: 'medium'
  },
  {
    endpoint: 'Biodegradation',
    yourScore: 82,
    industryAvg: 65,
    topQuartile: 90,
    concernLevel: 'low'
  },
  {
    endpoint: 'Bioaccumulation',
    yourScore: 89,
    industryAvg: 73,
    topQuartile: 93,
    concernLevel: 'low'
  }
];

// Chart-specific data for radar chart
export const chemicalSafetyRadarData = endpointBenchmarkData.map(item => ({
  endpoint: item.endpoint,
  yourScore: item.yourScore,
  industryAverage: item.industryAvg,
  topPerformer: item.topQuartile
}));

// Chart-specific data for bar chart  
export const chemicalSafetyBarData = endpointBenchmarkData.map(item => ({
  endpoint: item.endpoint,
  yourScore: item.yourScore,
  industryAverage: item.industryAvg,
  topPerformer: item.topQuartile
}));
